var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87599 2.37377L6.84315 2.35436C6.0801 1.90346 5.46247 1.53849 4.95452 1.29797C4.44331 1.05592 3.93067 0.88245 3.39841 0.934588C2.61889 1.01095 1.90892 1.41608 1.44662 2.04834C1.13096 2.48005 1.01951 3.00965 0.967834 3.57289C0.916485 4.13256 0.916494 4.84996 0.916504 5.73627V5.73627L0.916505 5.77443V16.2254L0.916504 16.2636C0.916494 17.1499 0.916485 17.8673 0.967834 18.427C1.01951 18.9902 1.13096 19.5198 1.44662 19.9515C1.90892 20.5838 2.61889 20.9889 3.39841 21.0653C3.93067 21.1174 4.44331 20.9439 4.95451 20.7019C5.46246 20.4614 6.08007 20.0964 6.8431 19.6455L6.87599 19.6261L15.7191 14.4006L15.7517 14.3813C16.4914 13.9443 17.0914 13.5897 17.5354 13.2692C17.9837 12.9458 18.3736 12.5888 18.5852 12.1083C18.8962 11.4021 18.8962 10.5977 18.5852 9.89157C18.3736 9.41107 17.9837 9.0541 17.5354 8.7306C17.0914 8.4101 16.4914 8.05558 15.7517 7.61851L15.7191 7.59927L6.87599 2.37377Z",
    fill: "#CCD6DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.0923ea842d0463862a659b4890205435.svg";
export { ForwardRef as ReactComponent };